import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { Occurrence } from '@klopotun/contracts';
import { restoreOccurrence } from '../requests/restore-occurrence.js';
import { unpayOccurrence } from '../requests/unpay-occurrence.js';
import { voidOccurrence } from '../requests/void-occurrence.js';
import { invalidateOccurrence } from './occurrence-cache.js';

export type OccurrenceStatusInput =
  | { action: 'unpay'; id: string }
  | { action: 'void'; id: string }
  | { action: 'restore'; id: string };

const changeOccurrenceStatus = (input: OccurrenceStatusInput): Promise<Occurrence> => {
  if (input.action === 'unpay') {
    return unpayOccurrence(input.id);
  }
  if (input.action === 'void') {
    return voidOccurrence(input.id);
  }
  return restoreOccurrence(input.id);
};

export const useOccurrenceStatusMutation = (): UseMutationResult<
  Occurrence,
  Error,
  OccurrenceStatusInput
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeOccurrenceStatus,
    onSuccess: (occurrence) => invalidateOccurrence(queryClient, occurrence),
  });
};
